module.exports = __webpack_public_path__ + "static/media/placeholder.a7f3b43e.svg";